import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './InteractiveMapFilters.css';
import React from 'react';
import InteractiveMapSearch from './components/InteractiveMapSearch';
import NestedFilters from './components/NestedFilters';
var InteractiveMapFilters = function InteractiveMapFilters(_ref) {
  var params = _ref.params,
    analytics = _ref.analytics,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView,
    mainTitle = _ref.mainTitle,
    rtl = _ref.rtl,
    chosenTypes = _ref.chosenTypes,
    fields = _ref.fields,
    facets = _ref.facets,
    defaultFacets = _ref.defaultFacets,
    facetsStats = _ref.facetsStats,
    showLabel = _ref.showLabel,
    resultsLabel = _ref.resultsLabel,
    nbHits = _ref.nbHits,
    clearAllLabel = _ref.clearAllLabel,
    selectAllLabel = _ref.selectAllLabel,
    setListingFilter = _ref.setListingFilter,
    resetFilterCallback = _ref.resetFilterCallback,
    day = _ref.day,
    days = _ref.days,
    Cancel = _ref.Cancel,
    FiltersCopy = _ref.FiltersCopy,
    isTagPage = _ref.isTagPage,
    lang = _ref.lang,
    hits = _ref.hits,
    dictionary = _ref.dictionary,
    imageDictionary = _ref.imageDictionary,
    firstQuery = _ref.firstQuery,
    resetAllFiltersCallback = _ref.resetAllFiltersCallback,
    searchIndex = _ref.searchIndex,
    isNestedFilters = _ref.isNestedFilters,
    search = _ref.search,
    requestSettingsForSearch = _ref.requestSettingsForSearch,
    handleAllowSearch = _ref.handleAllowSearch,
    allowSearch = _ref.allowSearch,
    defaultTypeValues = _ref.defaultTypeValues,
    handleResetFiltersFromSearch = _ref.handleResetFiltersFromSearch,
    activeListingItemId = _ref.activeListingItemId,
    handleDisableNestedFiltersFromSearch = _ref.handleDisableNestedFiltersFromSearch,
    filterPinsBySearch = _ref.filterPinsBySearch,
    getActivePopupOnMap = _ref.getActivePopupOnMap,
    activeTopPicks = _ref.activeTopPicks,
    toggleActiveTopPicks = _ref.toggleActiveTopPicks;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchVisible = _React$useState2[0],
    toggleSearchVisible = _React$useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(allowSearch ? 'search-mode' : '', " imfilters imfilters-padding")
  }, mainTitle && /*#__PURE__*/React.createElement("h4", {
    className: "imfilter-title "
  }, mainTitle), /*#__PURE__*/React.createElement("div", {
    className: "imfilters-header ".concat(allowSearch ? 'search-mode' : '')
  }, /*#__PURE__*/React.createElement(InteractiveMapSearch, {
    analytics: analytics,
    params: params,
    fields: search,
    dictionary: dictionary,
    toggleSearch: function toggleSearch() {
      return toggleSearchVisible(!searchVisible);
    },
    handleAllowSearch: handleAllowSearch,
    allowSearch: allowSearch,
    defaultTypeValues: defaultTypeValues,
    handleResetFiltersFromSearch: handleResetFiltersFromSearch,
    activeListingItemId: activeListingItemId,
    handleDisableNestedFiltersFromSearch: handleDisableNestedFiltersFromSearch,
    filterPinsBySearch: filterPinsBySearch,
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: toggleActiveTopPicks,
    hits: hits
  }), /*#__PURE__*/React.createElement("div", {
    className: "imfilters-header-nested-filters "
  }, /*#__PURE__*/React.createElement(NestedFilters, {
    fields: fields,
    params: params,
    facets: facets,
    defaultFacets: defaultFacets,
    facetsStats: facetsStats,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    selectAllLabel: selectAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    day: day,
    days: days,
    Cancel: Cancel,
    FiltersCopy: FiltersCopy,
    isTagPage: isTagPage,
    lang: lang,
    hits: hits,
    dictionary: dictionary,
    imageDictionary: imageDictionary,
    firstQuery: firstQuery,
    analytics: analytics,
    resetAllFiltersCallback: resetAllFiltersCallback,
    searchIndex: searchIndex,
    chosenTypes: chosenTypes,
    withMapModalView: withMapModalView,
    disabled: chosenTypes.length === 0 || chosenTypes.length > 1,
    isNestedFilters: isNestedFilters
  }))));
};
var commonStyles = "cyjm87j";
var ltrStyles = "l1nc4r5d";
var rtlStyles = "r142h99r";
export default InteractiveMapFilters;